import { useState } from 'react';
import { get, post, put, del } from '../../../../../components/hooks/apiFetch';

export const useTeamManagement = (inputIdentifier, currentUserAccess, showSucces, showError) => {
    const [team, setTeam] = useState([]);
    const [availableUsers, setAvailableUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingAvailableUsers, setLoadingAvailableUsers] = useState(false);

    const loadTeam = async () => {
        setLoading(true);
        try {
            const teamData = await get(`/api/TaskFileAccess/GetTeamAccesses/${encodeURIComponent(inputIdentifier)}`);
            const enhancedTeam = teamData.map(access => ({
                ...access,
                isCurrentUser: access.user.guid === currentUserAccess?.user.guid
            }));
            setTeam(enhancedTeam);
        } catch (error) {
            console.error('Ошибка загрузки команды:', error);
            showError('Ошибка загрузки команды');
        } finally {
            setLoading(false);
        }
    };

    const loadAvailableUsers = async () => {
        setLoadingAvailableUsers(true);
        try {
            const users = await get(`/api/TaskFileAccess/GetUsersForInvite/${encodeURIComponent(inputIdentifier)}`);
            setAvailableUsers(users);
        } catch (error) {
            console.error('Ошибка загрузки пользователей:', error);
            showError('Ошибка загрузки пользователей');
        } finally {
            setLoadingAvailableUsers(false);
        }
    };

    const refreshData = async () => {
        await loadTeam();
        await loadAvailableUsers();
    };

    const handleAddUserTaskAccess = async (userAccessData) => {
        try {
            const taskAccess = {
                user: userAccessData.user,
                role: userAccessData.role || 'Viewer',
                canManageTeam: userAccessData.canManageTeam || false,
                fileAccess: userAccessData.fileAccess || []
            };

            await post(`/api/TaskFileAccess/AddTaskAccesses/${encodeURIComponent(inputIdentifier)}`, [taskAccess]);
            await refreshData();
            showSucces('Пользователь успешно добавлен в команду');
            return true;
        } catch (error) {
            console.error('Ошибка добавления прав пользователю:', error);
            showError('Ошибка добавления прав пользователю');
            return false;
        }
    };

    const handleAddMultipleUserTaskAccesses = async (taskAccesses) => {
        try {
            await post(`/api/TaskFileAccess/AddTaskAccesses/${encodeURIComponent(inputIdentifier)}`, taskAccesses);
            await refreshData();
            showSucces(`Добавлено ${taskAccesses.length} пользователей в команду`);
            return true;
        } catch (error) {
            console.error('Ошибка добавления пользователей:', error);
            showError('Ошибка добавления прав пользователям');
            return false;
        }
    };

    const handleUpdateTaskAccesses = async (taskAccesses) => {
        try {
            await put(`/api/TaskFileAccess/UpdateTaskAccesses`, [taskAccesses]);
            await loadTeam();
            showSucces('Права пользователя успешно обновлены');
            return true;
        } catch (error) {
            console.error('Ошибка обновления прав пользователя:', error);
            showError('Ошибка обновления прав пользователя');
            return false;
        }
    };

    const handleDeleteTaskAccess = async (taskAccessGuid) => {
        try {
            await del(`/api/TaskFileAccess/DeleteTaskAccess/${encodeURIComponent(taskAccessGuid)}`);
            refreshData();
            showSucces('Пользователь удален из команды');
            return true;
        } catch (error) {
            console.error('Ошибка удаления пользователя:', error);
            showError('Ошибка удаления пользователя из команды');
            return false;
        }
    };

    const handleTransferCreatorRole = async (taskAccess) => {
        try {
            await put('/api/TaskFileAccess/TransferCreatorRole', taskAccess);
            await loadTeam();
            showSucces('Роль "Владельца" успешно передана');
        } catch (error) {
            console.error('Ошибка при передаче роли "Владельца" пользователю:', error);
            showError('Ошибка при передаче роли "Владельца" пользователю');
        }
    }

    return {
        team,
        availableUsers,
        loading,
        loadingAvailableUsers,
        loadTeam,
        loadAvailableUsers,
        refreshData,
        handleAddUserTaskAccess,
        handleAddMultipleUserTaskAccesses,
        handleUpdateTaskAccesses,
        handleDeleteTaskAccess,
        handleTransferCreatorRole
    };
};